module.exports = __webpack_public_path__ + "img/dimensie-sociaal_maatschappelijk_participeren.9a3eca9d.svg";